<template lang="pug">
.digit-code-input
    input.form-control(
        v-for="(digit, index) in internalValue"
        v-model="internalValue[index]"
        type="text"
        inputmode="numeric"
        pattern="[0-9]"
        maxlength="1"
        placeholder="_"
        ref="digit"
        required
        :name="`digit[${index}]`"
        :class="{ 'is-invalid': isInvalid }"
        @input="dataChange(index)"
        @keydown="(event) => handleSpecialKeys(index, event)"
        @paste="onPaste"
    )
</template>
<script>
export default {
    name: 'DigitCodeInput',

    emits: [ 'input' ],

    props: {
        digits: {
            type: Number,
            default: 6
        },

        isInvalid: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            internalValue: new Array(this.digits)
        };
    },

    methods: {
        dataChange(index) {
            if (this.internalValue[index] && index + 1 < this.internalValue.length) {
                this.$nextTick(() => {
                    this.$refs.digit[index + 1].focus();
                });
            }

            // can't use every as every skips empty slot
            for (const digit of this.internalValue) {
                if (!/\d/.test(digit)) {
                    this.$emit('input', '');
                    return;
                }
            }

            this.$emit('input', this.internalValue.join(''));
        },

        handleSpecialKeys(index, event) {
            if (event.key === 'Backspace' && !this.internalValue[index] && index > 0) {
                this.$set(this.internalValue, index - 1, '');
                this.$nextTick(() => {
                    this.$refs.digit[index - 1].focus();
                });
            }
            if (event.key === 'ArrowRight' && index + 1 < this.internalValue.length) {
                this.$nextTick(() => {
                    this.$refs.digit[index + 1].focus();
                });
            }
            if (event.key === 'ArrowLeft' && index > 0) {
                this.$nextTick(() => {
                    this.$refs.digit[index - 1].focus();
                });
            }
        },

        onPaste(event) {
            event.preventDefault();
            const data = event.clipboardData?.getData('text');
            if (!data) {
                return;
            }
            if (data.length === this.digits && Number.isInteger(Number(data))) {
                this.internalValue = Array.from(data);
                this.dataChange(this.digits - 1);
            }
        }
    }
};
</script>
